<!-- <ng-template #popTemplate>Testing: <div [innerHTML]="juvenileCase.getCaseNotes()"></div></ng-template> -->
<div class="panel-body ">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
        <div class="panel panel-default ">
            <div class="panel-title " id="{{'juvenile-caseDetails-caseInformation-caseNumber'}}">
             {{juvenileCase.getCaseCounty()}} {{juvenileCase.getCaseNumber()}}
             <!-- <span *ngIf="juvenileCase.getCaseNotes()!==''" popover='{{juvenileCase.getCaseNotes()}}'><i class="glyphicon glyphicon-comment"></i></span>        -->
             <!-- <span *ngIf="juvenileCase.getCaseNotes()!==''" [popover]="popTemplate"><i class="glyphicon glyphicon-comment"></i></span>        -->
             <span *ngIf="juvenileCase.getCaseNotes()!==''" [popover]="popTemplate" triggers="click" outsideClick="true"><i class="glyphicon glyphicon-comment"></i></span>       
             <ng-template #popTemplate><pre [innerHtml]="juvenileCase.getCaseNotes()"></pre></ng-template>
            </div>
            
    <div class="panel-body">
    <div class="row ">
      <div class="col-md-6 panel panel-default ">
        <div class="panel panel-default " *ngIf="juvenileCase.getFileStatus() !== ''">
          <div id="V085b" class="panel-title ">
            <span class="field-code "></span>File Status
          </div>
          <div class="panel-body ">{{juvenileCase.getFileStatus()}}</div>
        </div>
        <div class="panel panel-default " *ngIf="juvenileCase.getInterpretedNeeded() !== '' || juvenileCase.getInterpretedUsed() === 'YES'">
          <div id="V085b" class="panel-title ">
            <span class="field-code "></span>Interpreter
          </div>
              <div class="panel-body ">
                <dl class="dl-vertical ">
                  <dt id="V086"  class="summary-label ">
                    <span class="field-code ">V086 json='interpreterLanguage'</span>Needed
                  </dt>
                  <dd id="{{'juvenile-caseDetails-caseInformation-interpreterNeeded'}}">
                    {{juvenileCase.getInterpretedNeeded()}}
                  </dd>
                  <dt id="V087" class="summary-label ">
                    <span class="field-code ">V087 json='interpreterUsed'</span>Used
                  </dt>
                  <span>
                  <dd id="{{'juvenile-caseDetails-caseInformation-interpreterUsed'}}">
                    {{juvenileCase.getInterpretedUsed()}}
                  </dd></span>
                </dl>
              </div>
        </div>
        <div class="panel panel-default " *ngIf="juvenileCase.getCourtRoomCode() !== '' || juvenileCase.getCourtRoom() !== ''">
          <div id="V085b" class="panel-title ">
            <span class="field-code "></span>Courtroom
          </div>
          <div class="panel-body ">{{juvenileCase.getCourtRoomCode()}} - {{juvenileCase.getCourtRoom()}}</div>
        </div>
      </div>
  
      <div class="col-sm-6 panel panel-default ">
        <div class="panel panel-default " *ngIf="juvenileCase.getFileDestroyedPerRecordRetentionSchedule() !== ''">
          <div id="V076" class="panel-title ">
            <span class="field-code "></span>File Destroyed per Record Retention Schedule
          </div>
          <div class="panel-body ">{{juvenileCase.getFileDestroyedPerRecordRetentionSchedule()}}</div>
        </div>
        <div class="panel panel-default " *ngIf="juvenileCase.getGuardianAdLitemInvolved() !== ''">
          <div id="V077" class="panel-title ">
            <span class="field-code "></span>Guardian Ad Litem Involved
          </div>
          <div class="panel-body ">{{juvenileCase.getGuardianAdLitemInvolved()}}</div>
        </div>
        <div class="panel panel-default " *ngIf="juvenileCase.getFamilyCourtInvolved() !== ''">
          <div id="V078" class="panel-title ">
            <span class="field-code "></span>Family Court Involved
          </div>
          <div class="panel-body ">{{juvenileCase.getFamilyCourtInvolved()}}</div>
        </div>
        <div class="panel panel-default " *ngIf="juvenileCase.getJudgeName() !== ''">
          <div id="V078" class="panel-title ">
            <span class="field-code "></span>Judge
          </div>
          <div class="panel-body ">{{juvenileCase.getJudgeName()}}</div>
        </div>
      </div>  
    </div>
    </div>
    </div>
  </div>
  </div>
    


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/case-information/case-information.component.html